import type { CardColour, CardCurrency, CardResultKind, LimitCategory } from './cards.types';

export const CARDS_ROUTE_NAME = 'cards';
export const CARD_DETAILS_ROUTE_NAME = 'card-details';
export const ORDER_CARD_ROUTE_NAME = 'order-card';
export const ORDER_PHYSICAL_CARD_ROUTE_NAME = 'order-physical-card';
export const CARD_RESULT_ROUTE_NAME = 'card-result';

export const CARD_CURRENCIES = [
  'EUR',
  'USD',
  'GBP',
  'PLN',
  'CHF',
] as const satisfies readonly CardCurrency[];
export const CARD_FILTER_CURRENCIES = [
  'EUR',
  'USD',
  'GBP',
] as const satisfies readonly CardCurrency[];

export const CARD_COLOURS = [
  'grey',
  'rose',
  'violet',
  'orange',
  'green',
  'red',
  'blue',
  'black',
] as const satisfies readonly CardColour[];

export const LIMIT_CATEGORIES = [
  'atm',
  'in_store',
  'online',
] as const satisfies readonly LimitCategory[];

export const CARD_RESULT_KINDS = [
  'order-completed',
  'order-error',
  'blocked',
  'unblocked',
  'deactivated',
] as const satisfies readonly CardResultKind[];

export const PHYSICAL_CARD_FEE = 25;
export const VIRTUAL_CARD_FEE = 5;
export const ORDER_FEE_RATE = 0.01;

export const ORDER_ERROR_CURRENCY: CardCurrency = 'CHF';

export const SIMULATED_LATENCY_MS = 600;

export const EMPTY_STATE_QUERY = 'empty';
